import angular from 'angular';
import TilesService from './tiles.service';

let tilesModule = angular.module('tiles', []).service('tilesService', TilesService);

export default tilesModule;



// WEBPACK FOOTER //
// ./app/common/tiles/tiles.js